import Filters, { registerModuleFilters } from '@/utils/input/filters';

const { DateFilter, IsActiveFilter } = Filters;

const CreatedDateFilter = {
  ...DateFilter,
  label: 'global.text.createdDate',
};

export const filtersConfig = [IsActiveFilter, CreatedDateFilter];

registerModuleFilters('shortenedUrls', filtersConfig);
